import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const Ad = styled.div`
  margin: 0 auto;
  background-color: #fff;
  > div {
    width: 970px;
    height: 50px;
    margin: 0 auto;
  }
`
const AdComponent = () => {
  const [showModal, setShowModal] = useState(true)
  const [destroyModal, setDestroyModal] = useState(false)

  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] }
    window.googletag.cmd.push(() => {
      window.googletag.display('div-gpt-ad-educalt-1')
    })
  }, [window.googletag, window])

  useEffect(() => {
    if (showModal) {
      disablePageScroll()
    } else {
      enablePageScroll()
      setTimeout(() => {
        setDestroyModal(true)
      }, 300)
    }
  }, [showModal])

  const cancelButtonRef = useRef(null)

  return (
    <>
      {!destroyModal && (
        <div
          className="fixed inset-0 z-30 flex items-center justify-center overflow-y-auto"
          role="dialog"
          aria-modal="true"
          initialFocus={cancelButtonRef}>
          <div
            className={`fixed inset-0 transition-opacity bg-gray-300 bg-opacity-75 ease-in duration-200  ${!showModal &&
              'opacity-0'}`}
            aria-hidden="true"></div>
          <div
            className={`inline-block overflow-hidden transition-all duration-200 ease-in transform bg-white rounded-lg shadow-xl h-128 ${!showModal &&
              'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'}`}>
            <div className="absolute top-0 right-0">
              <button
                ref={cancelButtonRef}
                className="inline-flex items-center justify-center p-2 border border-gray-300 rounded-bl-lg bg-gray-50 hover:bg-gray-100 hover:border-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300"
                onClick={() => setShowModal(false)}>
                {' '}
                <span>cerrar aviso</span>
                <svg
                  className="w-6 h-6 text-gray-400"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  {' '}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />{' '}
                </svg>{' '}
              </button>
            </div>
            <Ad>
              <div id="div-gpt-ad-educalt-1" />
            </Ad>
          </div>
        </div>
      )}
    </>
  )
}

export default AdComponent
